// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"66":"acc2a1ee","869":"acc2a1ee","953":"acc2a1ee"}[chunkId] + ".chunk.css";
};